;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();const getPrimaryCredentialAndRole = ({
  providerPrimaryCredential,
  providerPrimaryRole,
}) => {
  // If providerPrimaryCredential exists, concatenate it with providerPrimaryRole
  if (providerPrimaryCredential) {
    return `${providerPrimaryCredential} ${providerPrimaryRole}`
  }

  // Otherwise, return only the providerPrimaryRole
  return providerPrimaryRole ? providerPrimaryRole : ""
}

export default getPrimaryCredentialAndRole
